import { EyeOutlined, EyeInvisibleOutlined } from "@ant-design/icons";
import { Button, Form, FormInstance, Input, Tooltip } from "antd";
import * as React from "react";

type ResetPasswordProps = {
  resetPasswordForm: FormInstance<any>
  changePassword: () => void
};

const ResetPassword: React.FC<ResetPasswordProps> = ({
  resetPasswordForm,
  changePassword
}) => {

  const [oldPassVisible, setOldPassVisible] = React.useState<boolean>(false)
  const [newPassVisible, setNewPassVisible] = React.useState<boolean>(false)
  const [oldType, setOldPassType] = React.useState<string>("password")
  const [newType, setNewPassType] = React.useState<string>("password")

  return (
    <div className="flex items-center bg-gray min-h-screen justify-center">
      <Form
        form={resetPasswordForm}
        name={"login"}
        layout="vertical"
        onFinish={changePassword}
      >
        <Form.Item
          label="User Name"
          name="userName"
          className="login"
          rules={[
            {
              required: true,
              message: "Please Enter Username"
            },
            {
              type: "email",
              message: "Please Enter Valid Email"
            },
            {
              whitespace: true,
              message: "User name should not be blank"
            }
          ]}>
          <Input className="user-login-btn" placeholder="Enter user name" />
        </Form.Item>
        <Form.Item
          rules={[
            {
              required: true,
              message: "Please Enter Old Password",
            },
            {
              whitespace: true,
              message: "Old Password should not be blank",
            },
          ]}
          validateTrigger={["onBlur", "onChange"]}
          label="Old Password"
          name="oldPassword"
          className="login"
        >
          <Input
            addonAfter={oldPassVisible ? (
              <Tooltip title="Hide Password" placement="bottom">
                <EyeOutlined onClick={() => {
                  setOldPassVisible(false)
                  setOldPassType("password")
                }} className="text-primaryText mx-4" />
              </Tooltip>
            ) : (
              <Tooltip title="Show Password" placement="bottom">
                <EyeInvisibleOutlined onClick={() => {
                  setOldPassVisible(true)
                  setOldPassType("text")
                }} className="text-primaryText mx-4" />
              </Tooltip>
            )
            }
            type={oldType}
            className="user-login-btn"
            placeholder="Enter Old Password"
          />
        </Form.Item>
        <Form.Item
          rules={[
            {
              required: true,
              message: "Please Enter New Password",
            },
            {
              whitespace: true,
              message: "New Password should not be blank",
            },
          ]}
          validateTrigger={["onBlur", "onChange"]}
          label="New Password"
          name="newPassword"
          className="login"
        >
          <Input
            addonAfter={newPassVisible ? (
              <Tooltip title="Hide Password" placement="bottom">
                <EyeOutlined onClick={() => {
                  setNewPassVisible(false)
                  setNewPassType("password")
                }} className="text-primaryText mx-4" />
              </Tooltip>
            ) : (
              <Tooltip title="Show Password" placement="bottom">
                <EyeInvisibleOutlined onClick={() => {
                  setNewPassVisible(true)
                  setNewPassType("text")
                }} className="text-primaryText mx-4" />
              </Tooltip>
            )
            }
            type={newType}
            className="user-login-btn"
            placeholder="Enter New Password"
          />
        </Form.Item>
        <div className="text-center flex space-x-6 justify-center">
          <Button type="primary" htmlType="submit" className="custom-primary-btn">Change Password</Button>
        </div>
      </Form>
    </div>
  );
};

export default ResetPassword;
